import React, {Component} from 'react'
import {MDBAlert, MDBListGroupItem, MDBListGroup} from 'mdbreact';
import firebase from "../../Config/firebase";
import SubscribedListItem from "./SubscribedListItem/SubscribedListItem";
import classes from './SubscribedList.module.css'

const db = firebase.firestore()

class SubscribedList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subscribedList: [],
            allCommunityData: [],
            isLoaded: false,
            isError: false,
            prevIndex: 10
        }
    }

    componentDidMount() {
        this.getMySubscribedList()
    }

    getMySubscribedList = () => {
        console.log(this.props.auth.uid)
        db.collection('Member')
            .doc(this.props.auth.uid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        subscribedList: Array.isArray(doc.data().subscribedList) ? doc.data().subscribedList : []
                    }, () => {
                        this.getSubscribedItem()
                    })
                } else {
                    this.setState({
                        isError: true
                    })
                }
            })
            .catch(err => console.log(err))

    }

    unsubscribe = (id) => {
        db.collection('Member')
            .doc(this.props.auth.uid)
            .update({
                subscribedList: firebase.firestore.FieldValue.arrayRemove(id)
            })
            .then(res => {
                this.removeItem(id)
            })
            .catch(err => console.log(err))
    }

    removeItem = (id) => {
        let newAllCommunityData = this.state.allCommunityData.filter(ele => ele.id !== id)
        this.setState({
            isLoaded: false
        }, () => {
            this.setState({
                allCommunityData: newAllCommunityData
            }, () => {
                this.setState({
                    isLoaded: true
                })
            })
        })
    }

    getSubscribedItem = (isNext, data) => {
        return new Promise((resolve, reject) => {
            if (isNext) {
                let allPromise = []
                let allCommunityData = []
                const index = this.state.subscribedList.length >= this.state.prevIndex ? this.state.prevIndex + 10 : this.state.subscribedList.length
                console.log(index)
                for (let i = this.state.prevIndex; i < index; i++) {
                    allPromise.push(
                        new Promise((resolve1, reject1) => {
                            db.collection('Community')
                                .doc(this.state.subscribedList[i])
                                .get()
                                .then(doc => {
                                    if (doc.exists) {
                                        let community = {
                                            ...doc.data()
                                        }
                                        community.id = doc.id
                                        allCommunityData.push(community)
                                        resolve1()
                                    } else {
                                        resolve1()
                                    }
                                })
                                .catch(err => console.log(err))
                        })
                    )
                }
                Promise.all(allPromise)
                    .then(res => {
                        this.setState({
                            prevIndex: this.state.prevIndex + 10,
                            allCommunityData: allCommunityData
                        }, () => {
                            this.setState({
                                isLoaded: true
                            })
                        })

                        resolve({
                            success: true,

                        })
                    })
            } else {
                let allPromise = []
                let allCommunityData = []
                const index = this.state.subscribedList.length >= 10 ? 10 : this.state.subscribedList.length
                console.log(index)

                for (let i = 0; i < index; i++) {
                    console.log(this.state.subscribedList[i])
                    allPromise.push(
                        new Promise((resolve1, reject1) => {
                            db.collection('Community')
                                .doc(this.state.subscribedList[i])
                                .get()
                                .then(doc => {
                                    if (doc.exists) {
                                        let community = {
                                            ...doc.data()
                                        }
                                        community.id = doc.id
                                        allCommunityData.push(community)
                                        resolve1()
                                    } else {
                                        resolve1()
                                    }
                                })
                                .catch(err => console.log(err))
                        })
                    )
                }
                Promise.all(allPromise)
                    .then(res => {
                        this.setState({
                            allCommunityData: allCommunityData
                        }, () => {
                            this.setState({
                                isLoaded: true
                            })
                        })
                        resolve({
                            success: true,
                            allCommunityData: allCommunityData
                        })
                    })
            }
        })

    }

    render() {
        return (
            <div>
                {this.state.isError ? <MDBAlert color="info">Error </MDBAlert> : ''}
                <MDBListGroup>
                    {
                        this.state.isLoaded ?
                            this.state.allCommunityData.length !== 0 ?
                                this.state.allCommunityData.map((e, index) => {
                                    return (
                                        <MDBListGroupItem key={'li' + index} className={classes.ListGroupItem}>
                                            <SubscribedListItem
                                                key={index}
                                                unsubscribe={this.unsubscribe}
                                                community={e}
                                                id={e.id}
                                            />
                                        </MDBListGroupItem>
                                    )
                                })
                                :
                                <div>
                                    訂閱以取得資料
                                </div>
                            : ''
                    }
                </MDBListGroup>
            </div>
        );
    }

}

export default SubscribedList